import React from 'react'
import { NavItem } from 'react-bootstrap'
import { LinkContainer, IndexLinkContainer } from 'react-router-bootstrap'
import SubMenu from './SubMenu'

class MenuModule extends React.Component {
	render() {
		const { item } = this.props;

        // We are excluding a given parent resource code?
        if (item.resourceCode === this.props.exclude) {
			return null;
		}
			
		if (item.path === '/') {
			// Navigation
			return (
				<IndexLinkContainer to={item.path}>
					<NavItem>{item.text}</NavItem>
				</IndexLinkContainer>
			);
		}
		else if (!item.childs || !item.childs.length) {
			// Not childs
			return (
				<LinkContainer to={item.path}>
					<NavItem>{item.text}</NavItem>
				</LinkContainer>
			);
		}
		else {
			// Submenu
			return (
				<SubMenu item={item} />
			);
		}
	}
}

export default MenuModule;


// WEBPACK FOOTER //
// ./src/fw/components/menu/MenuModule.js